import GTM from '@/utils/tracking/gtm'
import { FIRST_VIEW_GUEST_COUPON_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { useMainStore } from '@/store'
import Cookies from 'mj-cookie'

const FIRST_VIEW_GUEST_COUPON_EVENT_CATEGORY = 'coupon_test'

const FIRST_VIEW_GUEST_COUPON_EVENT_ACTION_VISIT = 'visit'
const FIRST_VIEW_GUEST_COUPON_EVENT_ACTION_VIEW = 'modal_view'
const FIRST_VIEW_GUEST_COUPON_EVENT_ACTION_GET = 'coupon_get'

const FIRST_VIEW_GUEST_COUPON_EVENT_LABEL = 'coupon_modal'
const FIRST_VISIT_GUEST_COUPON = '初回'
const VISIT_GUEST_COUPON = '毎回'

export const canDisplayFirstVisitGuestCouponModal = () => {
  const store = useMainStore()

  return !disableGaEvent() && !store.$state.auth_info && !Cookies.get('first_visit_guest_coupon_session_id')
}

export const sendFirstVisitGuestCouponVisitGaEvent = () => {
  sendFirstVisitGuestCouponGAEvent(FIRST_VIEW_GUEST_COUPON_EVENT_ACTION_VISIT, FIRST_VISIT_GUEST_COUPON)
}

export const sendAllVisitGuestCouponVisitGaEvent = () => {
  sendFirstVisitGuestCouponGAEvent(FIRST_VIEW_GUEST_COUPON_EVENT_ACTION_VISIT, VISIT_GUEST_COUPON)
}

export const displayFirstVisitGuestCouponModal = () => {
  const store = useMainStore()
  const { isBPattern } = useABTestV2(FIRST_VIEW_GUEST_COUPON_AB_TEST_CONFIG)

  Cookies.set('first_visit_guest_coupon_session_id', 'modal_shown')

  if (isBPattern) {
    store.MODAL({ name: 'FirstVisitGuestCouponModal', modalStyle: { padding: '10px' } })
  }
}

export const sendFirstVisitGuestCouponViewGaEvent = () => {
  if (disableGaEvent()) return

  sendFirstVisitGuestCouponGAEvent(FIRST_VIEW_GUEST_COUPON_EVENT_ACTION_VIEW, FIRST_VIEW_GUEST_COUPON_EVENT_LABEL)
}

export const sendFirstVisitGuestCouponGetGaEvent = () => {
  if (disableGaEvent()) return

  sendFirstVisitGuestCouponGAEvent(FIRST_VIEW_GUEST_COUPON_EVENT_ACTION_GET, FIRST_VIEW_GUEST_COUPON_EVENT_LABEL)
}

const disableGaEvent = () => !FIRST_VIEW_GUEST_COUPON_AB_TEST_CONFIG.enable

const sendFirstVisitGuestCouponGAEvent = (action: string, gaLabel: string) => {
  if (import.meta.server) return
  GTM.sendEventToGa({ category: FIRST_VIEW_GUEST_COUPON_EVENT_CATEGORY, action, label: gaLabel })
}
